import Nav from './Components/Nav';
import Footer from './Components/Footer';
import Slider from './Components/Slider';
import EventCard from './Components/EventCard';

import slide1 from './Media/Slides/Events_Slider/EventSlider_0000_bolivian_2560x742.webp';
import slide2 from './Media/Slides/Events_Slider/EventSlider_0001_salsa_on_stage-2560x742.webp';
import slide3 from './Media/Slides/Events_Slider/EventSlider_0002_2560x742.webp';
import slide4 from './Media/Slides/Events_Slider/EventSlider_0003_MissionandVision_2560x742.webp';

const slides = [
    {
        index: 0,
        filename: slide1,
        alt: "Canadian Salsa Festivals Project"
    },
    {
        index: 1,
        filename: slide2,
        alt: "Salsa festivals and live performances"
    },
    {
        index: 2,
        filename: slide3,
        alt: "Salsa in Toronto celebrations"
    },
    {
        index: 3,
        filename: slide4,
        alt: "Canadian Salsa Festivals Project community events"
    }
];

export default function Events() {
    return (
        <>
            <Nav />

            <Slider sliderJson={slides} />

            <section className='page-content'>

                <EventCard
                    eventName="Salsa in Toronto"
                    eventInfo="Discover Salsa in Toronto, Canada's celebration of Latin music, dance, food, arts and culture. Explore festivals, programs and cultural experiences happening throughout the year."
                    link="https://salsaintoronto.com/"
                />

                <EventCard
                    eventName="Festivals"
                    eventInfo="Explore the Salsa in Toronto Festival Series and discover current festivals featuring live music, dance, food, entertainment and cultural experiences."
                    link="https://salsaintoronto.com/festivals/"
                />

                <EventCard
                    eventName="Programs"
                    eventInfo="Discover year-round Salsa in Toronto programs and initiatives celebrating Latin culture through dance, arts, community programming and special events."
                    link="https://salsaintoronto.com/programs/"
                />

            </section>

            <Footer />
        </>
    );
}